fieldSpec